/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
 */

import { __ } from '@oat-sa-private/ui-core';

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_CONTENT_CREATOR = 'CONTENT_CREATOR';
export const ROLE_GROUP_CREATOR = 'GROUP_CREATOR';
export const ROLE_GROUP_MANAGER = 'GROUP_MANAGER';
export const ROLE_TEST_TAKER = 'TEST_TAKER';
export const ROLE_GRADER = 'GRADER';
export const ROLE_REVIEW_GRADER = 'REVIEW_GRADER';
export const ROLE_NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const ROLE_ALL = 'ALL';
export const ROLE_BATTERY = 'BATTERY';
export const ROLE_OFFLINE_UPLOADER = 'OFFLINE_UPLOADER';
export const ROLE_ONLINE_UPLOADER = 'ONLINE_UPLOADER';
export const ROLE_DASHBOARD_VIEWER = 'DASHBOARD_VIEWER';
export const ROLE_DATA_EXPLORER = 'DATA_EXPLORER';
export const ROLE_PUBLIC_SESSION_MANAGER = 'PUBLIC_SESSION_MANAGER';

export const ROLE_BACKOFFICE = 'ROLE_BACKOFFICE'; // this is not a real role. It represents any global roles. See README.md

const translations = {
    [ROLE_ADMIN]: __('Admin'),
    [ROLE_CONTENT_CREATOR]: __('Content creator'),
    [ROLE_GROUP_CREATOR]: __('Group creator'),
    [ROLE_GROUP_MANAGER]: __('Group manager'),
    [ROLE_TEST_TAKER]: __('Test taker'),
    [ROLE_GRADER]: __('Scorer'),
    [ROLE_BATTERY]: __('Battery manager'),
    [ROLE_OFFLINE_UPLOADER]: __('Offline uploader'),
    [ROLE_ONLINE_UPLOADER]: __('Online uploader'),
    [ROLE_DASHBOARD_VIEWER]: __('Dashboard viewer'),
    [ROLE_DATA_EXPLORER]: __('Data explorer viewer'),
    [ROLE_PUBLIC_SESSION_MANAGER]: __('Public Session Manager')
};

export const getUserFriendlyName = role => translations[role] ?? role;
